
import { defineComponent, PropType } from 'vue'
import { mapState } from 'vuex'
import { SubscribedPlanInfo } from '~/mixins/activeUserMixin'
import { RepositoryDetailModuleState } from '~/store/repository/detail'
import { Check, Run, ScaCheck } from '~/types/types'
import { resolveNodes } from '~/utils/array'

export default defineComponent({
  name: 'ReportCardView',
  props: {
    run: {
      type: Object as PropType<Run>,
      required: true
    },
    isPrInsightsEligible: {
      type: Boolean,
      default: true
    },
    canChangePlan: {
      type: Boolean,
      default: false
    },
    planInfo: {
      type: Object as PropType<SubscribedPlanInfo>,
      default: () => ({})
    }
  },
  computed: {
    ...(mapState('repository/detail', {
      defaultBranchName: (state: any) => state.repository?.defaultBranchName
    }) as {
      defaultBranchName: () => RepositoryDetailModuleState['repository']['defaultBranchName']
    }),
    checks(): Check[] {
      return resolveNodes(this.run.checks) ?? []
    },
    showNonDefaultBaseBranchTip(): boolean {
      const baseBranch = this.run.pullRequest?.baseBranch
      return Boolean(
        baseBranch && this.defaultBranchName && baseBranch !== this.defaultBranchName
      )
    },
    scaChecks(): ScaCheck[] {
      return resolveNodes(this.run.scaChecks) ?? []
    },
    provider(): string {
      return this.$route.params.provider
    },
    breadcrumbText(): string {
      if (this.run.isForDefaultBranch) {
        return this.run.commitMessage || this.run.commitOid?.substring(0, 7) || ''
      }
      return this.run.pullRequest?.title || this.run.pullRequestNumberDisplay || ''
    }
  }
})
